import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface CommandInputProps {
    onSend: (message: string) => void;
    disabled: boolean;
}

const CommandInput: React.FC<CommandInputProps> = ({ onSend, disabled }) => {
    const { t } = useTranslation(['conversationalEditor']);
    const [value, setValue] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!disabled) {
            inputRef.current?.focus();
        }
    }, [disabled]);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!value.trim() || disabled) return;
        onSend(value.trim());
        setValue('');
    };

    return (
        <form className="ce-command-input" onSubmit={handleSubmit}>
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={t('conversationalEditor:inputPlaceholder')}
                disabled={disabled}
                className="ce-command-input__field"
            />
            <button
                type="submit"
                disabled={!value.trim() || disabled}
                className="ce-command-input__send"
            >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 2L8 10M16 2L11 16L8 10L2 7L16 2Z" />
                </svg>
            </button>
        </form>
    );
};

export default CommandInput;
